export default `
  mutation updateTeamMember($id: String!, $projectId: String!, $workflowOrder: [String], $starredWorkflowOrder: [String]) {
    updateTeamMember(id: $id, projectId: $projectId, workflowOrder: $workflowOrder, starredWorkflowOrder: $starredWorkflowOrder) {
      id
      projectId
      workflowOrder
      starredWorkflowOrder
      createdAt
    }
  }
`
